<app-section #parentSection
             class="discount-codes-section"
             *ngIf="sectionVisible"
             [title]="title"
             [key]="key"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [formConfig]="formConfig">

  <ng-template #section>

    <app-text-field
            [errorsMap]="formFactoryService.errorsMap"
            [bean]="bean"
            [control]="formGroup.controls[fieldKey]"
            [fieldConfig]="formFactoryService.fieldConfig(fieldKey, formConfig)"
            [context]="formConfig.formKey"
    >
    </app-text-field>

  </ng-template>
</app-section>
